<template>
  <button
    class="transition-colors font-medium inline-block"
    :class="{
      'text-gray-900 bg-gray-100 hover:bg-gray-200': !disabled && color === 'gray',
      'text-white bg-sky-600 hover:bg-sky-200': !disabled && color === 'blue',
      'text-gray-400 bg-gray-50 hover:bg-gray-100': disabled && color === 'gray',
      'text-white bg-sky-300 hover:bg-sky-200': disabled && color === 'blue',
      'px-2': size === 'sm',
      'py-2 px-3': size === 'md',
      'py-3 px-3': size === 'lg'
    }"
    :disabled="disabled"
    @click="onClick()"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    click: Function,
    disabled: Boolean,
    color: String,
    size: String
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  },
}
</script>
